.inner {
  height: fit-content;
  max-height: fit-content;
}

.label {
  white-space: normal;
  height: fit-content;
  word-break: break-all;
}

.withoutText {
  padding: var(--mantine-spacing-xs);
}
